module.exports = __webpack_public_path__ + "img/BRCA2_CD8T.4347194c.png";